import { render, staticRenderFns } from "./StartBody.vue?vue&type=template&id=018ece5f&"
var script = {}
import style0 from "./StartBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports